import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loading from '../fixedComponents/Loading'
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export class LoadingOmniAuth extends Component {
  constructor( props ){
    super();
    this.state = { ...props };
  }

  componentDidMount(){
    const { client } = this.props;
    cookies.set('lastClickedId', client.lastClickedId, { path: '/' })
    window.location = this.state.loc;
  }

  render() {
    return <Loading />
  }
}

const mapStateToProps = state => ({
  client: state.client
});

export default connect(mapStateToProps)(LoadingOmniAuth)




// WEBPACK FOOTER //
// ./src/components/SignupLogin/LoadingOmniAuth.js